import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { errMsg, useAdminApi } from "@/lib/api";

export default function AdminsTab() {
  const call = useAdminApi();
  const [data, setData] = useState(null);
  const refresh = useCallback(() => call("get", "/users").then(setData), [call]);
  useEffect(() => {
    refresh();
  }, [refresh]);

  const setRole = async (id, role) => {
    try {
      await call("patch", `/users/${id}/role`, { role });
      toast.success("Role updated");
      refresh();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  if (!data) return <div className="h-24 animate-pulse rounded-xl bg-white/5" />;
  return (
    <div className="space-y-3" data-testid="admin-users">
      <p className="text-sm text-emerald-100/70">People who have signed in to the admin area. Only admins can open it.</p>
      {data.users.map((u) => (
        <div key={u.user_id} className="flex items-center justify-between gap-3 border-b border-white/5 py-2" data-testid={`user-row-${u.user_id}`}>
          <span className="truncate text-sm">{u.user_id}</span>
          <Select value={u.role} onValueChange={(v) => setRole(u.user_id, v)}>
            <SelectTrigger className="w-32 bg-black/20" data-testid={`user-role-${u.user_id}`}><SelectValue /></SelectTrigger>
            <SelectContent>{data.roles.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      ))}
    </div>
  );
}
